import { render, staticRenderFns } from "./BaseDownload.vue?vue&type=template&id=08b08931&"
import script from "./BaseDownload.vue?vue&type=script&lang=js&"
export * from "./BaseDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports